import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock } from 'lucide-react';
export function LocationSection() {
  return <section id="contacto" className="py-24 bg-kiron-dark relative" data-id="element-133">
      <div className="max-w-7xl mx-auto px-6" data-id="element-134">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16 text-center" data-id="element-135">
          <h2 className="text-4xl md:text-5xl font-oswald font-bold text-white mb-4" data-id="element-136">
            <span className="text-kiron-teal" data-id="element-137">Encontranos</span>
          </h2>
          <div className="w-20 h-1 bg-kiron-teal mx-auto" data-id="element-138"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-139">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-8" data-id="element-140">
            <div className="bg-kiron-black p-8 border-l-4 border-kiron-teal" data-id="element-141">
              <div className="flex items-start gap-4" data-id="element-142">
                <MapPin className="text-kiron-teal w-8 h-8 flex-shrink-0 mt-1" data-id="element-143" />
                <div data-id="element-144">
                  <h3 className="font-oswald text-2xl font-bold text-white uppercase tracking-wide mb-2" data-id="element-145">
                    Ubicación
                  </h3>
                  <p className="text-gray-300 text-lg" data-id="element-146">
                    Av. Presidente Perón 2596
                    <br data-id="element-147" />
                    San Miguel, Buenos Aires
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-kiron-black p-8 border-l-4 border-kiron-teal" data-id="element-148">
              <div className="flex items-start gap-4" data-id="element-149">
                <Clock className="text-kiron-teal w-8 h-8 flex-shrink-0 mt-1" data-id="element-150" />
                <div className="w-full" data-id="element-151">
                  <h3 className="font-oswald text-2xl font-bold text-white uppercase tracking-wide mb-4" data-id="element-152">
                    Horarios
                  </h3>
                  <ul className="space-y-3 text-gray-300" data-id="element-153">
                    <li className="flex justify-between border-b border-gray-800 pb-2" data-id="element-154">
                      <span className="font-medium" data-id="element-155">Lunes a Viernes</span>
                      <span data-id="element-156">7:00 a 22:00 hs</span>
                    </li>
                    <li className="flex justify-between border-b border-gray-800 pb-2" data-id="element-157">
                      <span className="font-medium" data-id="element-158">Sábados</span>
                      <span data-id="element-159">8:00 a 14:00 hs</span>
                    </li>
                    <li className="flex justify-between" data-id="element-160">
                      <span className="font-medium" data-id="element-161">Domingos</span>
                      <span data-id="element-162">9:00 a 13:00 hs</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="h-[400px] bg-kiron-darker relative overflow-hidden" data-id="element-163">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3286.7871687683732!2d-58.723381499999995!3d-34.5336198!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcbd55d47f8ce1%3A0xe88775eea284f710!2sKiron%20Performance!5e0!3m2!1ses!2sar!4v1776177827159!5m2!1ses!2sar" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Kiron Performance - Google Maps" className="absolute inset-0 w-full h-full" data-id="element-164" />
          </motion.div>
        </div>
      </div>
    </section>;
}